import { FC, ReactNode } from "react";
import { Flex } from "@chakra-ui/react";
import { Convex } from "./Convex";

type ChakraColorVariable = `var(--chakra-colors-${string})`;

interface Props {
  bg: ChakraColorVariable;
  bottom?: boolean;
  children: ReactNode;
  top?: boolean;
}

export const CurvedContainer: FC<Props> = ({ bg, bottom, children, top }) => {
  return (
    <Flex direction="column" w="full" zIndex={1}>
      {top && <Convex bg={bg} direction="up" />}
      <Flex bg={bg} justify="center" w="full">
        {children}
      </Flex>
      {bottom && <Convex bg={bg} direction="down" />}
    </Flex>
  );
};
